import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./en/translation.json";
import translationKO from "./ko/translation.json";

i18n
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    // debug: true,
    resources: {
      en: {
        translation: translationEN,
      },
      ko: {
        translation: translationKO,
      },
    },
  });

export default i18n;
